import React from 'react'
import SettingsPopover from "./SettingsPopover"
import screenfull, { Screenfull } from "screenfull"
import Config from '../../library/Config'
import { ReactComponent as SettingsIcon } from "../../icon/settings.svg"
import { ReactComponent as EnterFullScreenIcon } from "../../icon/enter-fullscreen.svg"
import { ReactComponent as ExitFullScreenIcon } from "../../icon/exit-fullscreen.svg"
import "../../css/Controls.css"

declare var document: any

interface ControlsProps {
  config: Config
  numberOfAds: number
  dashboardLink: string | null
  didChangeConfig: Function
}

interface ControlsState {
  showControls: boolean
  showPopover: boolean
  respondToMouseMove: boolean
  dismissalPending: boolean
  hideTimer?: any
}

export default class Controls extends React.Component<ControlsProps, ControlsState> {
  constructor(props: ControlsProps) {
    super(props)

    this.state = {
      showControls: false,
      showPopover: false,
      respondToMouseMove: true,
      dismissalPending: false
    }

    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)
  }

  componentDidMount() {
    window.addEventListener('mousemove', this.onMouseMove, false)
    window.addEventListener('mousedown', this.onMouseDown, false)
    window.addEventListener('mouseup', this.onMouseUp, false)
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.onMouseMove, false)
    window.removeEventListener('mousedown', this.onMouseDown, false)
    window.removeEventListener('mouseup', this.onMouseUp, false)
  }

  toggleSettings() {
    this.setState({ showPopover: !this.state.showPopover })
  }

  toggleFullscreen() {
    if (screenfull.isEnabled) {
      if ((screenfull as Screenfull).isFullscreen) {
        screenfull.exit()
      } else {
        screenfull.request()
      }
    }
  }

  onMouseMove(_e: any) {
    // Throttle the number of mouse events this responds to
    if (!this.state.respondToMouseMove) {
      return
    }

    this.setState({
      showControls: true,
      respondToMouseMove: false
    })

    // Show the cursor
    document.querySelector('body').style.cursor = 'auto'

    this.startHideTimer()

    // Allow another mouse event in 1/20 of a second
    setTimeout(() => {
      this.setState({ respondToMouseMove: true })
    }, 50)
  }

  dismissalClickIsValid(e: MouseEvent): boolean {
    let popover = document.getElementById('popoverContainer')
    var settingsButton = document.getElementById('settingsButton')

    if (popover === null || settingsButton === null) {
      return false
    }

    if (e.target === popover || popover.contains(e.target)
      || e.target === settingsButton || settingsButton.contains(e.target)) {
      return false
    }

    return true
  }

  onMouseDown(e: MouseEvent) {
    if (this.dismissalClickIsValid(e)) {
      this.setState({ dismissalPending: true })
    }
  }

  onMouseUp(e: MouseEvent) {
    if (this.dismissalClickIsValid(e) && this.state.dismissalPending) {
      this.setState({ showPopover: false })
    } else {
      this.setState({ dismissalPending: false })
    }
  }

  startHideTimer() {
    clearTimeout(this.state.hideTimer)

    let hideTimer = setTimeout(() => {
      if (this.state.showPopover) {
        return this.startHideTimer()
      }

      this.setState({ showControls: false })

      // Hide the cursor
      document.querySelector('body').style.cursor = 'none'
    }, 1000)

    this.setState({ hideTimer: hideTimer })
  }

  render() {
    return (
      <>
        <div id="controlsBackground" className={this.state.showControls ? "controlsVisible" : "controlsHidden"}></div>
        <div id="controls" className={this.state.showControls ? "controlsVisible" : "controlsHidden"}>

          {screenfull.isEnabled &&
            <button id="fullscreenButton" onClick={() => this.toggleFullscreen()}>
              {(screenfull as Screenfull).isFullscreen ?
                <>
                  <ExitFullScreenIcon />
                  <span className="text">Exit Full-screen</span>
                </> :
                <>
                  <EnterFullScreenIcon />
                  <span className="text">Enter Full-screen</span>
                </>
              }
            </button>
          }
          <button id="settingsButton" onClick={() => this.toggleSettings()}>
            <SettingsIcon />
            <span className="text">Settings</span>
          </button>
          <SettingsPopover
            show={this.state.showPopover}
            config={this.props.config}
            numberOfAds={this.props.numberOfAds}
            dashboardLink={this.props.dashboardLink}
            didChangeConfig={this.props.didChangeConfig}
          />
        </div>
      </>
    )
  }
}